<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="reserve-image-search-tooltip-modal-label" style="text-transform: uppercase">
                {{ $root.text('NEW FUNCTION') }}
            </h5>
            <button
                type="button"
                class="close"
                aria-label="Close"
                @click="onClose()"
            >
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <p v-html="intro()"></p>
            <a href="#" @click.prevent="resetReverseImageSearch()" style="text-transform: uppercase">
                {{ $root.text('click here') }}
            </a>
            {{ $root.text('{click here} to try this new function.', { 'click here': '' }) }}
        </div>
        <div v-if="!do_not_show_again" class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="doNotShowAgain()">
                {{ $root.text('Do not show again', null, true) }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                do_not_show_again: false
            }
        },
        mounted () {
            const cookieName = this.$root.app.client_id + '_ristt' + this.$root.user.id;
            if (this.$cookie.get(cookieName)) {
                this.do_not_show_again = true;
            }
        },
        methods: {
            onClose: function () {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
                $('#reverse-image-search-tooltip-modal').css('display', 'none');
                $('#reverse-image-search-tooltip-modal').removeClass('show');
            },
            resetReverseImageSearch: function () {
                if (!this.$root.client.similar_assets_search) {
                    return null;
                }
                this.onClose();
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                const component = this.$root.findComponent(appComponent, 'reverse-image-search');
                if (component) {
                    component.reset();
                    setTimeout(function () {
                        $('#reverse-image-search-modal').modal('show');
                    }, 500);
                }
            },
            doNotShowAgain: function () {
                this.onClose();
                this.$root.setCookie(this.$root.app.client_id + '_ristt' + this.$root.user.id, 1, '1Y');
                var vm = this;
                setTimeout(function () {
                    vm.do_not_show_again = true;
                }, 200);
            },
            intro: function () {
                let html = this.$root.text(
                    'Click the Reverse image search icon {icon} in the search field to quickly discover '
                        + 'visually similar images from across {system}.',
                    {
                        icon: '<span class="mx-2" style="font-size: 27px"><i class="fa-light fa-camera-viewfinder"></i>'
                            + '</span>',
                        system: this.$root.client.client_name
                    },
                    true
                );

                return html;
            }/*,
            clickHereToTry: function () {
                const text = this.$root.text('{Click here} to try this new function.');
                return text.replace(new RegExp(this.$root.text('click here'), "i"), '');
            }*/
        }
    }
</script>
